// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3MMcz","productName":"Table_productName__1zo-X"};